








import { defineClassComponent } from '@/hooks'
import { jointGoodsModelProvider } from '../model'
import { navigateBack } from '@/router'

export default defineClassComponent(
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()

      handleBackClick = () => {
        navigateBack()
      }
    },
)
